import { Injectable } from '@angular/core';

export type DeviceStateType = 'WORK' | 'WARN' | 'ERROR';
export type DeviceStatusType = 'PRODUCER' | 'DISTRIBUTOR' | 'CLIENT';

@Injectable({
  providedIn: 'root',
})
export class DeviceStaticDataService {
  statuses: { [key in DeviceStatusType]: string };
  states: { [key in DeviceStateType]: string };
  stateList: DeviceStateType[] = ['WORK', 'WARN', 'ERROR'];

  constructor() {
    this.states = {
      WORK: $localize`Работает`,
      WARN: $localize`Работает`,
      ERROR: $localize`Не работает`,
    };

    this.statuses = {
      PRODUCER: $localize`Производитель`,
      DISTRIBUTOR: $localize`Дистрибьютор`,
      CLIENT: $localize`Госпиталь`,
    };
  }
}
